import React from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

const LaporanFilterHeader = ({ unitKerja, sumberDana, handleOnChange }) => {
  return (
    <Form>
      <Row>
        {/* <Col>
          <FormGroup>
            <Label for="tahun_laporan">Tahun</Label>
            <Input
              id="tahun_laporan"
              name="tahun"
              type="select"
              defaultValue={""}
              onChange={handleOnChange}
            >
              <option value="">Semua</option>
              {tahunList.map((item) => (
                <option key={item}>{item}</option>
              ))}
            </Input>
          </FormGroup>
        </Col> */}
        {/* <Col>
          <FormGroup>
            <Label for="bulan_laporan">Bulan</Label>
            <Input
              id="bulan_laporan"
              name="bulan"
              type="select"
              defaultValue={""}
              onChange={handleOnChange}
            >
              <option value="">Semua</option>
              {bulanList.map((item) => (
                <option key={item}>{item}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="level_laporan">Level</Label>
            <Input
              id="level_laporan"
              name="level"
              type="select"
              defaultValue={""}
              onChange={handleOnChange}
            >
              <option value="">Semua</option>
              {levelList.map((item) => (
                <option key={item}>{item}</option>
              ))}
            </Input>
          </FormGroup>
        </Col> */}
        <Col>
          <FormGroup>
            <Label for="sumber_dana_laporan">Sumber Dana</Label>
            <Input
              id="sumber_dana_laporan"
              name="sumber_dana"
              type="select"
              defaultValue={""}
              onChange={handleOnChange}
            >
              <option value={"0"}>Semua</option>
              {sumberDana.map((item) => (
                <option key={item.pk} value={item.pk}>
                  {item.nama_sumber_dana}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="unit_kerja_laporan">Pilih DPSJ</Label>
            <Input
              id="unit_kerja_laporan"
              name="unit_kerja"
              type="select"
              defaultValue={""}
              onChange={handleOnChange}
            >
              <option value="">Semua</option>
              {unitKerja.map((item) => (
                <option key={item.pk}>{item.nama_unit_kerja}</option>
              ))}
            </Input>
          </FormGroup>
          {/* <Label for="filter_laporan">Pilih DPSJ</Label>
          <Input
            type="button"
            className="text-start"
            value={"Pilih DPSJ"}
            onClick={toggleFilterModal}
            onChange={handleOnChange}
          />
          <LaporanFilterModal
            modalOpen={filterModalOpen}
            toggle={toggleFilterModal}
            unitKerja={unitKerja}
            selectedUnitKerja={selectedUnitKerja}
            handleLihatFilter={handleLihatFilter}
          /> */}
        </Col>
      </Row>
    </Form>
  );
};

export default LaporanFilterHeader;
